export default __webpack_public_path__ + "static/media/spray_gun.819fffe5.png";